import React from 'react';
import I18n from 'i18n-js';

import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import ListingNudge from '../discovery/listing_nudge';
import AffirmLearnMoreModal from '@reverbdotcom/commons/src/components/affirm_learn_more_modal';

interface IProps {
  availableTermMonths?: (number | null)[] | null;
  buyerPrice: string;
  estimatedMonthlyPayment?: string;
  maxTermMonth: number;
  lowestAprAtMaxTerm?: number;
  splitPay?: boolean;
}

export function AffirmZeroPercentNudge({
  availableTermMonths,
  buyerPrice,
  estimatedMonthlyPayment,
  maxTermMonth,
  lowestAprAtMaxTerm,
  splitPay,
}: IProps) {
  const emptyRender = !estimatedMonthlyPayment;

  if (emptyRender) { return null; }

  const renderLearnMoreModal = () => (
    <AffirmLearnMoreModal
      estimatedMonthlyPayment={estimatedMonthlyPayment}
      buyerPrice={buyerPrice}
      maxTermMonth={maxTermMonth}
      availableTermMonths={availableTermMonths}
      zeroPercentFinancing
      lowestAprAtMaxTerm={lowestAprAtMaxTerm}
      splitPay={splitPay}
    />
  );

  const renderNudgeSubtitle = () => (
    <>
      <SanitizedRender
        html={
          I18n.t('discovery.item2AffirmCallout.asLowAsWithAffirm', {
            price: estimatedMonthlyPayment,
            tagOpen: '<strong>',
            tagClose: '</strong>',
          })
        }
        className="pr-space"
      />
      {renderLearnMoreModal()}
    </>
  );

  return (
    <div className="item2-pricing__affirm">
      <ListingNudge
        subclass="listing-nudge--affirm"
        title={I18n.t('discovery.item2AffirmCallout.zeroFinancing.nudgeTitle')}
        subtitle={renderNudgeSubtitle()}
      />
    </div>
  );
}

export default AffirmZeroPercentNudge;
